import jwt_decode from "jwt-decode";
import { UserTypes } from "enum/UserTypes";
import { AppResponse } from "../models/Response";
import { AuthService } from "./AuthService";

const STORAGE_KEY = "wooOnboardingSession";

export function getSignedInUserRole(): string | null {
  const token = AuthService.getToken();
  if (!token) {
    return null;
  }
  try {
    const data: { user_role?: string; role?: string } = jwt_decode(token);
    return data.user_role || data.role || null;
  } catch {
    return null;
  }
}

export function isSignedInZuluCustomer(): boolean {
  const role = getSignedInUserRole();
  return (
    role === UserTypes.BUSINESS_CUSTOMER || role === UserTypes.PERSONAL_CUSTOMER
  );
}

export function saveWooOnboardingSession(session: string): void {
  if (session) {
    sessionStorage.setItem(STORAGE_KEY, session);
  }
}

export function readWooOnboardingSession(): string {
  const params = new URLSearchParams(window.location.search);
  const fromQuery = params.get("wooSession") || "";
  if (fromQuery) {
    saveWooOnboardingSession(fromQuery);
  }
  return fromQuery || sessionStorage.getItem(STORAGE_KEY) || "";
}

export function clearWooOnboardingSession(): void {
  sessionStorage.removeItem(STORAGE_KEY);
}

export function wooSignInPath(session?: string): string {
  const value = session || readWooOnboardingSession();
  return value ? `/signin?wooSession=${encodeURIComponent(value)}` : "/signin";
}

export function wooSignUpPath(session?: string): string {
  const value = session || readWooOnboardingSession();
  return value ? `/signup?wooSession=${encodeURIComponent(value)}` : "/signup";
}

export function wooOnboardingPath(session?: string, shop?: string): string {
  const params = new URLSearchParams();
  const value = session || readWooOnboardingSession();
  if (value) {
    params.set("session", value);
  }
  if (shop) {
    params.set("shop", shop);
  }
  const query = params.toString();
  return query
    ? `/integrations/woocommerce/onboarding?${query}`
    : "/integrations/woocommerce/onboarding";
}

export function wooDashboardPath(session?: string, shop?: string): string {
  const params = new URLSearchParams();
  const value = session || readWooOnboardingSession();
  if (value) {
    params.set("session", value);
  }
  if (shop) {
    params.set("shop", shop);
  }
  const query = params.toString();
  return query
    ? `/integrations/woocommerce/dashboard?${query}`
    : "/integrations/woocommerce/dashboard";
}

export async function completeWooAccountLink(): Promise<{
  linked: boolean;
  error?: string;
}> {
  const session = readWooOnboardingSession();
  if (!session || !isSignedInZuluCustomer()) {
    return { linked: false };
  }
  const res = (await AuthService.linkWooCommerceStore(session)) as AppResponse<{
    alreadyLinked?: boolean;
    ordersReassigned?: number;
  }>;
  if (res.success) {
    return { linked: true };
  }
  if (res.errorCode === "FORBIDDEN" || res.errorCode === "UNAUTHORIZED") {
    return { linked: false };
  }
  return { linked: false, error: res.error };
}
